import { createFileRoute } from "@tanstack/react-router";
import { IncentivesFormPage } from "../pages/create";

export const Route = createFileRoute("/create")({
  component: RouteComponent,
});

function RouteComponent() {
  return <IncentivesFormPage />;
}
